import { Alert } from '@op/opds.opux';
import { useTranslation } from 'react-i18next';
import { type LinkObject } from '../../../types';
import { isContentOnly } from '../../../utils';
import LocalizedTextList from '../LocalizedTextList';

const InsuranceEventsAlert = () => {
  const { t } = useTranslation(['individualLife']);
  const localizationKey = isContentOnly()
    ? 'authenticatedPurchase.insuranceEventsAlertMobileApp'
    : 'authenticatedPurchase.insuranceEventsAlert';
  const content: Array<string | LinkObject> = t(localizationKey, {
    returnObjects: true,
  });

  return (
    <Alert embedded>
      <LocalizedTextList texts={content} />
    </Alert>
  );
};

export default InsuranceEventsAlert;
